import React from 'react';
import {Box, Button, useToast, useClipboard} from '@chakra-ui/react';
import {Copy} from '@carbon/icons-react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import {atomOneLight} from 'react-syntax-highlighter/dist/esm/styles/hljs';

export const CodeSnippet = ({
  code,
  language = 'javascript',
}: {
  code: string;
  language?: string;
}) => {
  const toast = useToast();
  const {onCopy} = useClipboard(code);

  const clipboardCopiedToast = () => {
    toast({
      title: 'Script copied to clipboard',
      status: 'success',
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Box position="relative">
      <Box position="absolute" top="10px" right="25px" zIndex={1}>
        <Button
          bgColor="white"
          leftIcon={<Copy />}
          size="sm"
          variant="outline"
          onClick={() => {
            onCopy();
            clipboardCopiedToast();
          }}
        >
          Copy Code
        </Button>
      </Box>
      <Box
        borderRadius="xl"
        borderColor="kgray.200"
        borderWidth="1px"
        maxH="200px"
        overflow="hidden"
      >
        <Box maxH="200px" overflowY="auto">
          <SyntaxHighlighter
            customStyle={{fontSize: '12px', padding: '10px'}}
            language={language}
            showLineNumbers
            style={atomOneLight}
          >
            {code}
          </SyntaxHighlighter>
        </Box>
      </Box>
    </Box>
  );
};
